import { FC } from 'react'
import { SvgProps } from './svgProps'

const SlippersIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    fill={color || '#000000'}
    width={width || '32'}
    height={height || '32'}
    viewBox="-4 0 36.72 36.72"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Slippers" transform="translate(-221.592 -280.37)">
      <path
        id="Path_1"
        data-name="Path 1"
        d="M245.3,283.8c-6.8-4.1-8.3,7.6-8.3,7.6-.1,1.2-.1,2.4-.2,3.4a10.58,10.58,0,0,1,5.7-3.1l.3-1.4a1.02,1.02,0,0,1,2,.4l-.3,1.6a22.149,22.149,0,0,1,3.7,8C250.4,295.5,252.6,288.2,245.3,283.8Z"
      />
      <path
        id="Path_2"
        data-name="Path 2"
        d="M237.7,296.9a8.986,8.986,0,0,0-1.2,6,1.012,1.012,0,0,1-.8,1.2.778.778,0,0,1-.8-.2l-.3.9a9.579,9.579,0,0,1-.3-2.2h-.4a1.04,1.04,0,0,1-.6-1.3,8.147,8.147,0,0,0-4.8-10.4c-1.4,1.4-5.4,5.9-4.2,9.6l1,1.6a1.076,1.076,0,0,1-.3,1.4.9.9,0,0,1-.5.1h-.2c.4,2.7.5,4.7.5,4.7s.3,7,5.2,6.5a6.212,6.212,0,0,0,3.3-1.3h0a5.657,5.657,0,0,0,3.9,3.4c4.8,1.4,6.3-5.4,6.3-5.4a46.17,46.17,0,0,1,1.5-4.8,1.421,1.421,0,0,1-.6-.2,1.071,1.071,0,0,1-.1-1.4l1.3-1.5c1.7-2.6-1.1-7.6-2.8-9.9A7.972,7.972,0,0,0,237.7,296.9Z"
      />
      <path
        id="Path_3"
        data-name="Path 3"
        d="M227.2,287.6a.945.945,0,0,1,1-1,1,1,0,0,1,1,1v1.3a10.3,10.3,0,0,1,5.2,4.5c.1-1.1.3-2.3.5-3.6,0,0,.7-11.8-6.7-9-7.8,2.9-7.1,10.8-5.8,16a18.993,18.993,0,0,1,4.9-7.6Z"
      />
    </g>
  </svg>
)

export default SlippersIcon
